import SearchEndpoint from "../../api/endpoint/SearchEndpoint";


export const getData = async <T>(
    apiEndpoint: string, 
    page: number, 
    pageSize: number,
    sort: { column: string | null; direction: "asc" | "desc" | "none", parameters?: Record<string, any> }
): Promise<{data: T[], total: number} | string> => 
{

    let errors: string | null = null;
    const searchEndpoint = new SearchEndpoint(apiEndpoint, pageSize, 3);

    try{
        const result = await searchEndpoint.pagedSearch(page, {
            sortColumn: sort.column || undefined,
            sortDirection: sort.direction === "none" ? undefined : sort.direction,
            parameters: sort.parameters
        });

        if(result.errors && result.errors.length > 0) {
            errors = result.errors.map((e: any) => e.message || 'Unknown error').join('; ');
            console.error('Search failed: ', result.errors);
            return errors;
        } else {
            return {data: result.data.results as T[], total: result.data.total};
        }
    } catch(err: any) {
        console.error('Search error: ', err);
        errors = err?.message || 'Search failed';
        return errors!;
    }
}